import { Lazy } from "../core/lazy";
import { PanelVm } from "./panel-vm";
import { Logger } from "../logger/logger";

export class PanelToggleGroupVm {
	private static readonly instancesByGroupName: { [groupName: string]: PanelToggleGroupVm } = {};
	private static readonly collapsedSize = 40;
	public static getInstance = (groupName: string): PanelToggleGroupVm => {
		if (!PanelToggleGroupVm.instancesByGroupName[groupName]) {
			PanelToggleGroupVm.instancesByGroupName[groupName] = new PanelToggleGroupVm();
		}
		return PanelToggleGroupVm.instancesByGroupName[groupName];
	}

	private items: IPanelItem[] = [];

	public registerPanel = (panel: PanelVm) => {
		this.items.push({
			panel,
			height: panel.contentHeight(),
			heightCorrection: panel.contentHeightCorrection(),
		});
		panel.isCollapsed.subscribe(() => this.resizePanels());
	}

	private resizePanels = () => {
		let expandedPanels = this.items.filter((item) => !item.panel.isCollapsed());
		let collapsedPanels = this.items.filter((item) => item.panel.isCollapsed());

		let heightSum = expandedPanels.map((item) => item.height).reduce((a, b) => a + b, 0);
		let scaleFactor = 100 / heightSum;

		let collapsedHeight = collapsedPanels.length * PanelToggleGroupVm.collapsedSize;
		let heightCorrection = collapsedHeight / expandedPanels.length;

		for (let item of expandedPanels) {
			item.panel.contentHeight(item.height * scaleFactor);
			item.panel.contentHeightCorrection(item.heightCorrection + heightCorrection);
		}
	}
}

interface IPanelItem {
	panel: PanelVm;
	height: number;
	heightCorrection: number;
}